import React, { useState, useEffect } from "react";
import { Card, Skeleton } from "antd";
import HTTP from "../../services/httpService";
import { useParams } from "react-router-dom";
import CustomHeader from "../common/Header";
import CustomTable from "../common/Table";
import { useQuery } from "react-query";

const columns = [
    {
        title: "Ticket Id",
        dataIndex: "id",
        key: "id",
        sorter: () => {},
    },
    {
        title: "Project",
        dataIndex: "project_name",
        key: "project_name",
        sorter: () => {},
    },
    {
        title: "Key",
        dataIndex: "ticket_key",
        key: "ticket_key",
        sorter: () => {},
    },
    {
        title: "Type Of Issue",
        dataIndex: "issue_type",
        key: "issue_type",
        sorter: () => {},
    },
    {
        title: "Priority",
        dataIndex: "priority",
        key: "priority",
        sorter: () => {},
    },
    {
        title: "Assignee",
        dataIndex: "assignee_name",
        key: "assignee_name",
        sorter: () => {},
    },
    {
        title: "Created By",
        dataIndex: "creator_name",
        key: "creator_name",
        sorter: () => {},
    },
    {
        title: "Status",
        dataIndex: "status",
        key: "status",
        sorter: () => {},
    },
];

function JiraTicketsTable() {
    const { range: range_id } = useParams();
    const staff_id = localStorage.getItem("x-dashboard-staffid");

    const [formData, setFormData] = useState({
        staff_id,
        range_id,
        limit: 10,
        page: 0,
    });
    const [totalRecords, setTotalRecords] = useState(0);
    const [ticketData, setTicketData] = useState([]);

    const {
        status: jiraTicketStatus,
        data: jiraTicketDataRes,
        refetch: fetchJiraTicketData,
    } = useQuery(
        "jiraTicketsTable",
        async () => {
            return await HTTP("/analytics/getJiraTicketsByAge", {
                ...formData,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        fetchJiraTicketData();
    }, []);

    useEffect(() => {
        fetchJiraTicketData();
    }, [formData]);

    useEffect(() => {
        if (jiraTicketStatus === "success") {
            const { data: ticket_data, total } = jiraTicketDataRes;
            setTicketData(ticket_data);
            setTotalRecords(total);
        }
    }, [jiraTicketStatus, jiraTicketDataRes]);

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, field } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 1 : 2;
            others.sort_by = field;
        } else {
            delete formData.sorting;
            delete formData.sort_by;
        }

        const newFormData = {
            ...formData,
            ...others,
        };

        setFormData(newFormData);
    }

    return (
        <>
            <Card className="dashboard-container">
                <CustomHeader />
                {!ticketData.length ? (
                    <Skeleton
                        active
                        title={false}
                        paragraph={{ rows: 20, width: 40 }}
                    />
                ) : (
                    <CustomTable
                        columns={columns}
                        tableData={ticketData}
                        noOfrecords={totalRecords}
                        handleTableChange={handleTableChange}
                        rowKey="id"
                        className="dashboard-table"
                    />
                )}
            </Card>
        </>
    );
}

export { JiraTicketsTable };
